export const TitleLoader = () => (
  <div className="flex justify-center items-center flex-col w-full animate-pulse">
    <div className="h-14 bg-grey-scale-coin rounded-full w-1/3 mb-4"></div>
    <div className="h-8 bg-grey-scale-coin rounded-full w-1/4 mb-4"></div>
  </div>
);

export const CounterAndSubsLoader = () => (
  <div className="flex justify-between items-center w-full animate-pulse">
    <div className="h-8 bg-grey-scale-coin rounded-full w-48 mb-4"></div>
    <div className="h-8 bg-grey-scale-coin rounded-full w-48 mb-4"></div>
  </div>
);

export const CardLoader = () => (
  <div className="mt-10 flex flex-col lg:flex-row justify-between items-center w-full animate-pulse">
    <div className="h-[520px] lg:h-[600px] rounded-lg bg-grey-scale-coin w-full lg:w-1/3 m-4 lg:mr-5"></div>
    <div className="h-[520px] lg:h-[600px] rounded-lg bg-grey-scale-coin w-full lg:w-1/3 m-4 lg:mx-5 "></div>
    <div className="h-[520px] lg:h-[600px] rounded-lg bg-grey-scale-coin w-full lg:w-1/3 m-4 lg:ml-5"></div>
  </div>
);

export const HelperCardLoader = () => (
  <div className="mx-20 animate-pulse flex items-center flex-col justify-center">
    <div className="h-14 bg-grey-scale-coin rounded-full w-1/3 mb-20"></div>
    <div className="flex w-full justify-between items-center">
      <div className="h-48 rounded-lg bg-grey-scale-coin w-1/3 mr-5"></div>
      <div className="h-48 rounded-lg bg-grey-scale-coin w-1/3 mx-5 "></div>
      <div className="h-48 rounded-lg bg-grey-scale-coin w-1/3 ml-5"></div>
    </div>
  </div>
);

export const ComparisionTableLoader = () => (
  <div className="mx-10 mt-10 flex justify-center flex-col items-center animate-pulse">
    <div className="h-14 bg-grey-scale-coin rounded-full w-1/3 mb-4"></div>
    <div className="mt-10 flex justify-between items-center w-full">
      <div className="h-[500px] rounded-lg bg-grey-scale-coin w-1/3 mr-5"></div>
      <div className="h-[500px] rounded-lg bg-grey-scale-coin w-1/5 mx-5 "></div>
      <div className="h-[500px] rounded-lg bg-grey-scale-coin w-1/5 mx-5"></div>
      <div className="h-[500px] rounded-lg bg-grey-scale-coin w-1/5 ml-5"></div>
    </div>
  </div>
);

export const FAQLoader = () => (
  <div className="mx-10 mt-10 flex justify-center flex-col items-center animate-pulse">
    <div className="h-14 bg-grey-scale-coin rounded-full w-1/3 mb-14"></div>
    <div className="h-[500px] rounded-lg bg-grey-scale-coin w-1/3"></div>
  </div>
);

export const TermsAndConditionsLoader = () => (
  <div className="mx-10 mt-10 flex justify-center flex-col items-center animate-pulse">
    <div className="h-14 bg-grey-scale-coin rounded-full w-full mb-4"></div>
    <div className="mt-10 flex justify-between items-center w-full">
      <div className="h-[500px] rounded-lg bg-grey-scale-coin w-full mr-5"></div>
    </div>
  </div>
);
export const TermsAndConditionsModalLoader = () => (
  <div className="mx-10 mt-10 flex justify-center flex-col items-center animate-pulse">
    <div className="mt-10 flex justify-between items-center w-full">
      <div className="h-[100px] rounded-lg bg-grey-scale-coin w-full mr-2"></div>
    </div>
  </div>
);
